import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import Section from 'components/common/Section';
import { Outlet } from 'react-router-dom';
import '../App.css'

const BodyBlackLayout = () => {
  document.body.style.backgroundColor = '#262523'; 

  return (
    <Section className="py-0" style={{backgroundColor:'#262523', minHeight:'100vh'}}>
      <Row className="flex-center" style={{backgroundColor:'#262523', minHeight:'100vh'}}> 
        <Outlet />  
      </Row>
    </Section>
  );
};

export default BodyBlackLayout;
